import * as React from 'react';
import { setDisplayName, compose } from 'recompose';
import { Section } from 'ui/shared/Section';
import { CameraTree } from './CameraTree';
import { CameraFilter } from './CameraFilter';

const styles: { [name: string]: React.CSSProperties } = {
    filter: {
        height: '24px',
    },
    tree: {
        position: 'absolute',
        top: '28px',
        left: 0,
        right: 0,
        bottom: 0,
        fontSize: '.9em',
    },
};

type OwnProps = {
    style?: React.CSSProperties;
};

export const RawCameraTreeSection = ({ style }: OwnProps) =>
    <Section
        titleKey="1066"
        style={ style }
    >
        <div style={ styles.filter }>
            <CameraFilter/>
        </div>
        <div style={ styles.tree }>
            <CameraTree/>
        </div>
    </Section>
;

export const CameraTreeSection = compose<OwnProps, OwnProps>(
    setDisplayName('CameraTreeSection'),
)(RawCameraTreeSection);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/sidePanel/CameraTreeSection.tsx